<template>
    <button @click="$emit('click', $event)">{{text}}</button>
</template>

<script>
export default {
    props:{
        text:{
            type:String,
            default: 'Más información'
        }
    }
}
</script>

<style lang="scss" scoped>
button{
    background-color: #EDEDFF;
    border: 1px solid #A297FA;
    font-size: 12px;
    padding: .5em 0;
    color: black;
    margin-right: 0;
    line-height: 1.5;
    text-align: center;
    height: 32px;
    &:disabled{
        background-color: #F5F5F5;
        cursor: not-allowed;
        color: #999999;
        border-color: #CCCCCC;
    }
}
</style>